import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BaseTranslateModule } from '@nx-ahs/base-translate';

import { SearchModule } from '@nx-ahs/search';

import { IonicModule } from '@ionic/angular';
import { ButtonOpenComponentModalComponent } from './button-open-component-modal/button-open-component-modal.component';
import { CustomSearchComponent } from './custom-search/custom-search.component';
import { LabelListComponent } from './label-list/label-list.component';
import { ProviderSearchResultListComponent } from './provider-search-result-list/provider-search-result-list.component';

@NgModule({
	declarations: [
		CustomSearchComponent,
		ButtonOpenComponentModalComponent,
		ProviderSearchResultListComponent,
		LabelListComponent
	],
	imports: [CommonModule, SearchModule, IonicModule, BaseTranslateModule],
	exports: [LabelListComponent]
})
export class TripettoComponentsModule {}
